import { createPortal } from "react-dom";
import * as s from "./ModalTemplateStyled";
import { forwardRef } from "react";

type Props = {
  center?: boolean;
  children?: React.ReactNode;
  className?: string;
};

const ModalTemplate = forwardRef<HTMLDivElement, Props>(
  ({ center, children, className }: Props, ref) => {
    return (
      <>
        {createPortal(
          <s.Container
            ref={ref}
            center={center}
            className={`${className} drag-cancel-content`} // grid layout 에서 background 에 있는 item drag 시 event bubble 막기위함
          >
            {children}
          </s.Container>,
          document.body
        )}
      </>
    );
  }
);

export default ModalTemplate;
